import React, {useEffect, useState} from 'react';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import {withStyles} from '@material-ui/core/styles';

import Sitelist from '../../../reserves/routes/ReserveNew/sitelist';

import {makeStyles} from '@material-ui/core/styles';
import {addressimage, addressimagehomessize, deletereserve, deletehome, checktokenapi} from "../../../../../api/api";
import {blue, green, purple} from "@material-ui/core/colors";
import IconButton from '@material-ui/core/IconButton'

import {useMediaQuery} from 'react-responsive'
import {useDispatch, useSelector} from "react-redux";
import {
    TelegramShareButton,
    WhatsappShareButton, FacebookShareCount, TwitterIcon,
    WhatsappIcon,
    TelegramIcon,
} from "react-share";
import Slide from '@material-ui/core/Slide';
import Switch from "@material-ui/core/Switch";
import ShareButton from 'react-web-share-button';
import URLSearchParams from "url-search-params";
import {useLocation} from "react-router-dom";
import {userSignInSuccess} from "../../../../../actions";


const useStyles = makeStyles((theme) => ({
    root: {
        fontFamily: 'iransans',
        padding: '20px 10px',
        '& .MuiTextField-root': {
            width: '100%',
            fontFamily: 'iransans',
        },
        '& .MuiAlert-message': {

            fontFamily: 'iransans',
        },


        '& .MuiFormHelperText-root': {

            fontFamily: 'iransans',
            marginTop: 5,
            marginLeft: 0


        },


        '& .MuiTypography-root': {

            fontFamily: 'iransans',
        },

        '& .MuiListItemText-secondary': {

            fontFamily: 'iransans',
            marginTop: 10,
        },

        '& .MuiTypography-body1': {

            fontFamily: 'iransans',

        },


        '& .MuiTypography-h6': {

            fontFamily: 'iransans',

        },
        '& .MuiButton-root': {

            fontFamily: 'iransans',

        },
        '& .MuiMenu-paper': {

            right: 'auto',

        },
        '& .MuiTypography-colorTextSecondary': {
            color: '#222'
        }
        // '& .MuiListItem-button': {
        //
        //     fontFamily: 'iransans',
        //    border:'1px solid #dadada',
        //   borderRadius: 4,
        //
        // },

    },

    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
    red: {

        color: '#f44336',


    },

    underlinetext: {

        fontSize: '0.75rem',
        marginTop: 5,
        color: '#f44336',
        fontFamily: 'iransans',


    },


    borderred: {
        fontFamily: 'iransans',
        border: '1px solid #f44336',
        borderRadius: 4,
        fontSize: 5,


    },
    border: {
        fontFamily: 'iransans',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: 4,
        fontSize: 5,
        marginBottom: 0,
        color: 'rgba(0, 0, 0, 0.54)'

    },

    paper: {
        width: '80%',
        maxHeight: 435,
    },

    sendpic: {
        margin: '0 auto',
        marginBottom: 15,
        textAlign: 'center',
        '&:hover': {
            cursor: 'pointer',
        },
    },

    button: {
        fontSize: 18,
        fontWeight: 'bold',
        height: 43,
        width: '100%',
        fontFamily: 'iransans',
        color: '#dadada',
        backgroundColor: '#3f51b5',
        '&:hover': {
            backgroundColor: '#172b95',
        },
    },

    input2: {
        fontFamily: 'iransans',
        width: '100%'
    },
    input: {
        fontFamily: 'iransans',
        width: '100%',
        marginTop: 15
    },
    formControl: {
        fontFamily: 'iransans',
        width: '100%',
        marginBottom: 15,

    },

    wrapper: {
        marginTop: 15,
        position: 'relative',
    },
    buttonSuccess: {
        fontSize: 18,
        fontWeight: 'bold',
        height: 43,
        width: '100%',

        fontFamily: 'iransans',
        color: '#dadada',
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },

    iconButton: {
        padding: 10,
        fontSize: 15,
        fontFamily: 'iransans'
    },
    divider: {
        height: 28,
        margin: 4,
    },

    direction: {
        direction: 'rtl',
        width: 150,
        height: 40
    },

    fontright: {
        fontFamily: 'iransans',
        textAlign: 'right',
        marginRight: 10,
        width: 100
    },
    fontleft: {
        fontFamily: 'iransans',
        textAlign: 'right',
        marginLeft: 10
    }

    ,
    center: {

        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'

    },

    customMaxWidth: {
        maxWidth: "none" // arbitrary value
    }


}));

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    border: {
        fontFamily: 'iransans',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: 10,
        fontSize: 5,
        display: 'flex',
        marginBottom: 0,
        color: 'rgba(0, 0, 0, 0.54)'

    },


});


function toPersianNum(num, dontTrim) {

    if (num == null) {
        return '۰'
    }

    var i = 0,

        dontTrim = dontTrim || false,

        num = dontTrim ? num.toString() : num.toString().trim(),
        len = num.length,

        res = '',
        pos,

        persianNumbers = typeof persianNumber == 'undefined' ?
            ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'] :
            persianNumbers;

    for (; i < len; i++)
        if ((pos = persianNumbers[num.charAt(i)]))
            res += pos;
        else
            res += num.charAt(i);

    return res;
}


const DialogTitle = withStyles(styles)((props) => {
    const {children, classes, onClose, ...other} = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h8">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon/>
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});


const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(1),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);


let typecalendar = false;

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const useQuery = () => new URLSearchParams(useLocation().search);
const Checksitelist = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();
    // const {id, Name, Code, state, city, image, Roomnumber} = props.product;
    const [open, setOpen] = React.useState(false);
    const [id, setId] = React.useState(0);
    const [Name, setName] = React.useState('');
    const [Code, setCode] = React.useState('');
    const [openchecksite, setOpenchecksite] = React.useState(false);
    const [openchecksitelittle, setOpenchecksitelittle] = React.useState(false);
    const [openfull, setOpenfull] = React.useState(false);
    const [dialogclose, setDialogclose] = React.useState(false);
    const [loader, setLoader] = React.useState(false);
    const [share, setShare] = React.useState(false);
    const [shareurl, setShareurl] = React.useState("");
    const [menuState, setMenuState] = React.useState(false);
    const [lastsecond, setLastsecond] = React.useState(true);
    const [reserveready, setReserveready] = React.useState(true);
    const [anchorEl, setAnchorEl] = React.useState(undefined);
    const [switchhpossibility, setSwitchhpossibility] = React.useState(false);
    const [checktoken, setChecktoken] = useState(false);
    const isMobile = useMediaQuery({query: `(max-width: 760px)`});
    const query = useQuery();

    useEffect(() => {
        setId(query.get('id'));
        setName(query.get('name'));
        setCode(query.get('code'));
        setOpenchecksite(true)
        console.log(props.product)


        if (query.get('token') == null) {

        } else {
            // alert(query.get('token') + ' armin');
            // alert(location.pathname);

            var body = new FormData();
            body.append('token', query.get('token'));
            checktokenapi(body)
                .then((response) => {

                    if (response.data.errorCode === 0) {
                        localStorage.setItem('user_id', 'Token ' + query.get('token'));
                        dispatch(userSignInSuccess(query.get('token')))
                        setChecktoken(true);
                    } else {
                        setChecktoken(false);
                    }

                })
                .catch((error) => {
                    debugger;

                })
        }


    }, []);


    const handleCloseChecksite = () => {
        setOpenchecksite(false);
        if (window.Android) {
            window.Android.CloseWebView();
        }

    };

    const handleCloseChecksitelittle = () => {
        setOpenchecksitelittle(false);

    };

    return (
        <div elevation={2} style={{paddingRight: 6, paddingLeft: 6, paddingBottom: 0, paddingTop: 0}}
             className={`col-xl-3 col-md-4 col-sm-6 col-12 tr-${id}`}>
            {/*<div className="card product-item">*/}

            {checktoken ?
                <Dialog fullScreen TransitionComponent={Transition}
                        onClose={handleCloseChecksite} open={openchecksite}>
                    <div style={{
                        display: 'flex', justifyContent: 'space-between',
                        alignItems: 'center', width: '100%'
                    }}>
                        {typecalendar ?
                            <div style={{
                                display: 'flex',
                                margin: 10,
                                fontSize: 15,
                                fontFamily: 'iransans',
                                fontWeight: 'bold'
                            }}>

                                <div> ثبت قیمت در سایت ها</div>
                                <div style={{marginRight: 5}}> {Name} - {Code} </div>

                            </div>
                            :
                            <div style={{
                                display: 'flex',
                                margin: 10,
                                fontSize: 15,
                                fontFamily: 'iransans',
                                fontWeight: 'bold'
                            }}>

                                <div> ثبت رزرو در سایت ها</div>
                                <div style={{marginRight: 5}}> {Name} - {Code} </div>
                            </div>
                        }

                        <IconButton onClick={handleCloseChecksite} aria-label="Close">
                            <CloseIcon/>
                        </IconButton>
                    </div>

                    <DialogContent dividers>
                        <Sitelist homeid={id}  handleCloseChecksite={handleCloseChecksite}/>
                        {/*<Calendar2 homeid={id} typecalendar={typecalendar} toedit={props.toedit} openchecksite={onOpenchecksite}/>*/}
                    </DialogContent>
                </Dialog>
                :
                null
            }
            {checktoken ?
                <Dialog fullWidth={true}
                        maxWidth='xs' TransitionComponent={Transition}
                        onClose={handleCloseChecksitelittle} open={openchecksitelittle}>
                    <div style={{
                        display: 'flex', justifyContent: 'space-between',
                        alignItems: 'center', width: '100%'
                    }}>
                        {typecalendar ?
                            <div style={{
                                display: 'flex',
                                margin: 10,
                                fontSize: 15,
                                fontFamily: 'iransans',
                                fontWeight: 'bold'
                            }}>

                                <div> ثبت قیمت در سایت ها</div>
                                <div style={{marginRight: 5}}> {Name} - {Code} </div>

                            </div>
                            :
                            <div style={{
                                display: 'flex',
                                margin: 10,
                                fontSize: 15,
                                fontFamily: 'iransans',
                                fontWeight: 'bold'
                            }}>

                                <div> ثبت رزرو در سایت ها</div>
                                <div style={{marginRight: 5}}> {Name} - {Code} </div>
                            </div>
                        }

                        <IconButton onClick={handleCloseChecksitelittle} aria-label="Close">
                            <CloseIcon/>
                        </IconButton>
                    </div>

                    <DialogContent dividers>
                        <Sitelist homeid={id} handleCloseChecksite={handleCloseChecksitelittle}/>
                        {/*<Calendar2 homeid={id} typecalendar={typecalendar} toedit={props.toedit} openchecksite={onOpenchecksite}/>*/}
                    </DialogContent>
                </Dialog>
                :
                null
            }
        </div>
    )
};

export default Checksitelist;

